module.exports = __webpack_public_path__ + "static/media/yushan_package.162dfc6b.webp";